import React from 'react';
import {SpotlightPage} from 'epic-ue-spotlight';
import styled from 'styled-components';
import {SpotlightPageData, getInitialCmsPageSharedValues, useCmsData, getUrlPattern} from 'epic-ue-shared';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import {useLocation} from 'react-router-dom';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {ueClassicLightTheme, ueDarkTheme, UeThemeProvider} from 'epic-ue-theme';
import Error404 from '../error/Error404';

const SpotlightWrap = styled.div`
    .article-tags {
        display: none;
    }

    .article-top-details .article-core {
        border-bottom: 1px solid rgb(237, 237, 237);
        span {
            font-size: 0.7em;
            color: ${(p) => p.theme.palette.text.primary};
        }
    }

    .social-sharing-wrapper ul li {
        background: rgb(186, 186, 186);
        &:hover {
            background: rgb(212, 212, 212);
        }
    }

    .copy a {
        color: #0078f2;
    }

    #feed-news {
        & > div,
        p,
        * {
            background: transparent !important;
            color: ${(p) => p.theme.palette.text.primary};
        }
    }

    .feed-item {
        color: ${(p) => p.theme.palette.text.primary};
        .feed-date span {
            color: ${(p) => p.theme.palette.text.primary};
        }
    }
`;

const NewsDetailView = (): JSX.Element => {
    const {pathname} = useLocation();
    const pageSlug = getUrlPattern({pathname});
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<SpotlightPageData>(pageSlug);

    if (cmsLoading) {
        return (
            <div className="news">
                {getHelmetForMetaTags(pageData)}
                <LoadIndicator />
            </div>
        );
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    const theme = pageData.theme;
    const themeToUse = theme === 'LIGHT' ? ueClassicLightTheme : ueDarkTheme;

    return (
        <UeThemeProvider theme={themeToUse}>
            <SpotlightWrap>
                <SpotlightPage
                    pageData={pageData}
                    cmsLoading={cmsLoading}
                    urlPattern={pageSlug}
                    disableContentTypeLabelClick
                    publisherName="Epic Games"
                    publisherLogo="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
                    feedItemTags={[]}
                />
            </SpotlightWrap>
        </UeThemeProvider>
    );
};

NewsDetailView.getInitialSharedValues = getInitialCmsPageSharedValues();

export default NewsDetailView;
